var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "builder" }, [
    _vm.activeStep === "1"
      ? _c("div", { staticClass: "builder__container" }, [
          _c("div", { staticClass: "builder__pretitle" }, [
            _vm._v("Report Type"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "builder__title" }, [
            _vm._v("What are you looking for?"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "builder__types" },
            _vm._l(_vm.types, function (type, index2) {
              return _c(
                "div",
                {
                  key: index2,
                  staticClass: "builder__type",
                  on: {
                    click: function ($event) {
                      return _vm.selectType(type.type)
                    },
                  },
                },
                [_vm._v("\n        " + _vm._s(type.label) + "\n      ")]
              )
            }),
            0
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.activeStep === "2"
      ? _c("div", { staticClass: "builder__container" }, [
          _c("div", { staticClass: "builder__pretitle" }, [
            _vm._v("Customisation"),
          ]),
          _vm._v(" "),
          _vm.reportType === "country"
            ? _c("div", [
                _c("div", { staticClass: "builder__title" }, [
                  _vm._v("Select your country"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "builder__checkboxs" }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.reportType === "requirement"
            ? _c("div", [
                _c("div", { staticClass: "builder__title" }, [
                  _vm._v("Select your license names."),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "builder__checkboxs" },
                  [
                    _c(
                      "el-checkbox-group",
                      {
                        model: {
                          value: _vm.chosenLicenses,
                          callback: function ($$v) {
                            _vm.chosenLicenses = $$v
                          },
                          expression: "chosenLicenses",
                        },
                      },
                      _vm._l(_vm.licenses, function (item) {
                        return _c("el-checkbox", {
                          key: item,
                          attrs: { label: item },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.activeStep === "3"
      ? _c("div", { staticClass: "builder__container" }, [
          _c("div", { staticClass: "builder__pretitle" }, [
            _vm._v("Jurisdictions"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "builder__title" }, [
            _vm._v("Add your jurisdictions"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "builder__checkboxs" }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.activeStep === "4"
      ? _c("div", { staticClass: "builder__container" }, [
          _c("div", { staticClass: "builder__pretitle" }, [
            _vm._v("Custom report"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "builder__title" }, [_vm._v("Content...")]),
          _vm._v(" "),
          _c("div", { staticClass: "builder__checkboxs" }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }